import { IdleWarningDialog } from './IdleWarningDialog';
import { useIdleLogout } from './useIdleLogout';

import { isPhoneDevice } from '@/lib/device';

/**
 * Mount ONCE inside the authenticated shell (AppShell). Runs the inactivity
 * engine for the whole CRM and shows the warning dialog when idle crosses the
 * threshold. Renders nothing while the user is active.
 *
 * Not on phones (2026-09-29). A phone sits locked in a pocket for most of the
 * day, so the 15-minute clock logged people out between every notification:
 * tap an alert, land on the login page. The phone's own lock screen is the
 * guard there. Laptops and tablets keep the auto-logout unchanged.
 */
export const IdleLogout = (): React.JSX.Element | null =>
  isPhoneDevice() ? null : <IdleLogoutEngine />;

const IdleLogoutEngine = (): React.JSX.Element | null => {
  const { phase, remainingMs, extend, extending } = useIdleLogout();

  if (phase !== 'warning') return null;

  return <IdleWarningDialog remainingMs={remainingMs} onExtend={extend} extending={extending} />;
};
